import getOntologyKeyRegex from './getOntologyKeyRegex'

// if negative lookaheads are not supported, we can use ($|\\W) and ([^'^\w]|$) with $2 instead of (?!\\w) and (?!\\w|')
export default function createOntologyRegexesFromKey(key) {
  return {
    regexPluralPossessive: getOntologyKeyRegex(
      key,
      'regexPluralPossessiveLowercased',
      key => new RegExp(`(^|\\b)${key.toLowerCase()}s'(?!\\w)`, 'i'),
    ),
    regexPlural: getOntologyKeyRegex(
      key,
      'regexPluralLowercased',
      key => new RegExp(`(^|\\b)${key.toLowerCase()}s(?!\\w|')`, 'i'),
    ),
    regexSingularPossessive: getOntologyKeyRegex(
      key,
      'regexSingularPossessiveLowercased',
      key => new RegExp(`(^|\\b)${key.toLowerCase()}'s(?!\\w)`, 'i'),
    ),
    regexSingular: getOntologyKeyRegex(
      key,
      'regexSingularLowercased',
      key => new RegExp(`(^|\\b)${key.toLowerCase()}(?!\\w)`, 'i'),
    ),
    regexKeyInsensitive: getOntologyKeyRegex(
      key,
      'regexKeyInsensitive',
      key => new RegExp(`${key}`, 'i'),
    ),
  }
}
